import { useEffect } from 'react'

const useManipulateTemporalColumns = (listContractsProps, listContracts, setListContracts, forceListMerge, setForceListMerge) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                listContracts.forEach(contract => {
                    contract.l_props.forEach(contractProp => {
                        const prop = listContractsProps.find(prop => prop.id === contractProp.contractPropId);
                        contract["custom_" + prop.id + "_" + prop.valType + "_" + prop.shortName] = prop.valType === "str" ? contractProp.strVal : (prop.valType === "num" ? contractProp.numVal : contractProp.cplId)
                    });
                });

                if (forceListMerge) {
                    setForceListMerge(false);
                }
                
                setListContracts(listContracts);
            }
            catch (error) {
                if (forceListMerge) {
                    setForceListMerge(false);
                }
            }
        }
        
        if ((listContractsProps !== null && listContracts !== null) || forceListMerge === true) {
            doIt()
        }
    }, [listContractsProps, listContracts, setListContracts, forceListMerge, setForceListMerge]);
}

export {
    useManipulateTemporalColumns
}